import classNames from 'classnames';

import { StatusType } from '../../types/enums';

import { ReactComponent as OkIcon } from './icon-ok.svg';
import { ReactComponent as WarningIcon } from './icon-warning.svg';
import { ReactComponent as ErrorIcon } from './icon-error.svg';
import { ReactComponent as Loading } from './icon-loading.svg';
import { ReactComponent as NotSetIcon } from './circle-regular.svg';

import styles from './Status.module.scss';

interface StatusProps {
  icon: JSX.Element;
  value: keyof typeof StatusType;
  type: keyof typeof StatusType;
  title?: string;
}

const Status = ({ icon: Icon, type, value, title }: StatusProps) => (
  <div
    className={classNames(styles.status, {
      [styles.statusError]: StatusType[type] === StatusType.ERROR,
      [styles.statusNA]: StatusType[type] === StatusType.NA,
      [styles.statusNotSet]: StatusType[type] === StatusType.IGNORE,
      [styles.statusUnavailable]: StatusType[type] === StatusType.UNAVAILABLE
    })}>
    {title && <div className={styles.title}>{title}</div>}
    {Icon}
    {StatusType[value]}
  </div>
);

export const iconByWebsiteStatus = {
  [StatusType.ERROR]: <ErrorIcon />,
  [StatusType.WARNING]: <WarningIcon />,
  [StatusType.OK]: <OkIcon />,
  [StatusType.NA]: <Loading />,
  [StatusType.IN_PROGRESS]: <Loading />,
  [StatusType.IGNORE]: <NotSetIcon />,
  [StatusType.UNAVAILABLE]: <WarningIcon />
};

export default Status;
